import { BasicModel } from './basic.model';

export class VehicleAccessory extends BasicModel<VehicleAccessory> {
    accessoryType?: { code: string, description: string };
    brand?: string;
    insuredAmountCost = 0;
    model?: string;
    publicId?: string;
    serialNumber?: string;
}
